import { render, staticRenderFns } from "./FinancialStatement.vue?vue&type=template&id=c5161bd4&"
import script from "./FinancialStatement.vue?vue&type=script&lang=js&"
export * from "./FinancialStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports